import { Injectable } from '@angular/core';

/**
 * Plays the chat notification sound.
 * Kept in its own service so components stay testable
 * (specs can mock this instead of touching HTMLAudioElement).
 */
@Injectable({
  providedIn: 'root'
})
export class ChatSoundService {
  private audio: HTMLAudioElement = null;

  constructor() {
    try {
      this.audio = new Audio();
      this.audio.src = 'assets/sound/mixkit-bell-notification-933.wav';
      this.audio.load();
    } catch (e) {
      this.audio = null;
    }
  }

  play(): void {
    if (!this.audio) { return; }
    try {
      this.audio.currentTime = 0;
      this.audio.play();
    } catch (e) {
      // Autoplay blocked or no audio device — safe to ignore.
    }
  }
}
